module.exports = __webpack_public_path__ + "static/media/img_minigame_fish_character.d7833382.png";